<template>
  <div class="line-container">
    <svg :width="svgWidth" :height="svgHeight">
      <line
        :x1="startPos.x"
        :y1="startPos.y"
        :x2="direction === 'horizontal' ? endPos.x - 10 : endPos.x"
        :y2="endPos.y"
        stroke="rgb(118, 118, 118)"
        stroke-linejoin="round"
        stroke-width="1"
        :marker-end="`url(#arrowhead-${direction})`"
      />
    </svg>
  </div>
</template>

<style scoped>
.line-container {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 0;
}
</style>

<script>
export default {
  props: {
    startElementId: String,
    endElementId: String,
    offsetParentId: String,
    refreshKey: Number,
    spacingStartElement: {
      type: Number,
      default: 0
    },
    spacingEndElement: {
      type: Number,
      default: 0
    },
    offsetStartElement: {
      type: Number,
      default: 0
    },
    offsetEndElement: {
      type: Number,
      default: 0
    },
    direction: {
      type: String,
      default: 'horizontal'
    }
  },
  data () {
    return {
      startPos: { x: 0, y: 0 },
      endPos: { x: 0, y: 0 },
      svgWidth: 0,
      svgHeight: 0
    }
  },
  mounted () {
    this.updateLinePositions()
    window.addEventListener('resize', this.updateLinePositions)
    this.$nextTick(() => {
      this.updateLinePositions()
    })
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.updateLinePositions)
  },
  methods: {
    updateLinePositions () {
      const startElement = document.getElementById(this.startElementId)
      const endElement = document.getElementById(this.endElementId)
      const startOffsetParent = this.offsetParentId ? document.getElementById(this.offsetParentId) : startElement?.offsetParent
      const endOffsetParent = endElement?.offsetParent

      if (!startElement || !endElement || !startOffsetParent || !endOffsetParent) {
        this.svgWidth = 0
        this.svgHeight = 0
        return
      }

      const startRect = startElement.getBoundingClientRect()
      const endRect = endElement.getBoundingClientRect()

      if (this.direction === 'vertical') {
        this.startPos = {
          x: startRect.left - startOffsetParent.getBoundingClientRect().left + startRect.width / 2 + this.offsetStartElement,
          y: startRect.top - startOffsetParent.getBoundingClientRect().top + startRect.height + this.spacingStartElement
        }

        this.endPos = {
          x: endRect.left - startOffsetParent.getBoundingClientRect().left + endRect.width / 2 + this.offsetEndElement,
          y: endRect.top - startOffsetParent.getBoundingClientRect().top - this.spacingEndElement
        }
      } else {
        this.startPos = {
          x: startRect.right - startOffsetParent.getBoundingClientRect().left - this.spacingStartElement,
          y: startRect.top - startOffsetParent.getBoundingClientRect().top + startRect.height / 2 + this.offsetStartElement
        }

        this.endPos = {
          x: endRect.left - startOffsetParent.getBoundingClientRect().left + this.spacingEndElement,
          y: endRect.top - startOffsetParent.getBoundingClientRect().top + endRect.height / 2 + this.offsetEndElement
        }
      }

      this.svgWidth = startOffsetParent.offsetWidth
      this.svgHeight = startOffsetParent.offsetHeight
    }
  },
  watch: {
    refreshKey () {
      this.$nextTick(() => {
        this.updateLinePositions()
      })
    }
  }
}
</script>
